import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Card, Col, Layout, Row, Spin } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { confirmEmailChange } from '../../Http/users/emailChange';
import { clearLocalSession } from '../../Http/auth/session';
import logo from '../Login/images/logo_v_png.png';
import '../Login/style.scss';

// PT-04: landing page for the email-change verification link.
const ConfirmEmailPage = () => {
	const [result, setResult] = useState(null);
	const [, , removeCookie] = useCookies(['Authorization']);

	useEffect(() => {
		const token = new URLSearchParams(window.location.search).get('token');
		if (!token) {
			setResult({ success: false, message: 'Invalid or missing token.' });
			return;
		}
		confirmEmailChange(token).then((r) => {
			if (r.success) {
				// The account's login identity changed: drop the session held in this browser so the
				// user signs in again with the new address (PT-04 review note).
				removeCookie('Authorization', { path: '/' });
				clearLocalSession();
			}
			setResult(r);
		});
	}, []);

	return (
		<Layout>
			<Content>
				<Row justify='center' align='middle' style={{ minHeight: '100vh' }}>
					<Col xs={22} sm={16} md={12} lg={10} xl={8} xxl={7}>
						<Card className='verifycode-card' bordered={false}>
							<img className='logo' src={logo} alt='logo' />
							{result === null ? (
								<div style={{ textAlign: 'center' }}><Spin /> Confirming your email address...</div>
							) : (
								<>
									<div className={result.success ? 'login-message' : 'error-message'}>{result.message}</div>
									<div style={{ textAlign: 'center', marginTop: 16 }}>
										<Link to='/login'>Go to login</Link>
									</div>
								</>
							)}
						</Card>
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default ConfirmEmailPage;
